var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendaryS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38079 1H11V11H1V6.34616H1.76923V5.61538H2.53849V6.38462H1.76923V9.46154H2.56539V8.69231H3.33462V7.92308V7.15385H4.87308V6.38462H5.64231V5.62318H4.88077V4.8578H5.64616V5.61538H6.41154V4.84615H7.18077V3.25384H8.7V2.51931H9.46539V3.28469H8.71923V4.07692H7.95V4.84615H7.20382V5.61538H6.43459V6.38462H5.66536V7.15385H4.89613V7.92308H4.15V8.69231H3.38077V9.46154H2.61154V10.2308H7.22692V9.46154H7.97306V10.2308H9.50771V9.46154H8.76154V8.69231H9.53077V9.46154H10.3V7.92308H9.51152V7.15385H10.2769V2.53846H9.48846V1.76923H6.41154V2.48461H7.18077V3.25384H6.41154V2.53846H5.64231V1.76923H6.38079V1ZM8.74229 5.61538H9.48846V7.15385H8.74229V5.61538ZM8.71923 4.84615V5.61538H7.97306V4.84615H8.71923ZM4.91923 8.69231V7.92308H5.66536V8.69231H4.91923ZM5.68846 9.46154V8.69231H7.20382V9.46154H5.68846ZM2.55769 4.8424H3.32308V5.60778H2.55769V4.8424ZM5.63846 2.51931H4.87308V3.28469H5.63846V2.51931ZM8.71923 7.91932H7.95385V8.68471H8.71923V7.91932ZM7.18462 7.15385H7.95V7.91923H7.18462V7.15385ZM7.18462 6.38837H6.41923V7.15376H7.18462V6.38837ZM3.32308 4.06555H4.10385V3.28478H4.87308V4.84247H4.10385V4.83093H3.32308V4.06555ZM3.32308 6.38837H2.55769V7.15376H3.32308V6.38837Z",
    fill: "#33F1FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendaryS);
export default __webpack_public_path__ + "static/media/legendary-s.daab40a9b03601810b1c3dd2e0f68323.svg";
export { ForwardRef as ReactComponent };